import React from 'react'
import ContactHero from '../components/contact/ContactHero'
import ContactFormSection from '../components/contact/ContactFormSection'
import ContactBenefitsSection from '../components/contact/ContactBenefitsSection'
import SEO from '../components/seo/SEO'

export default function Contact() {
  return (
    <>
      <SEO
        title="Contact Us | Logo Branded Door Mats Zambia - Get a Quote"
        description="Contact Logo Branded Door Mats Zambia for custom logo door mat quotes. Phone: +260981282836, Email: Care@logobrandeddoormats.co.zm. Located in Lusaka, Zambia. Available 24/7 for all your matting needs."
        keywords="contact door mats Zambia, door mat quote, custom mat inquiry, branded mats contact, mat supplier Zambia, door mat phone number, matting services contact"
        url="https://www.logobrandeddoormats.co.zm/contact"
        image="https://www.logobrandeddoormats.co.zm/images/sectionimages/contact page.png"
      />
      <ContactHero />
      <ContactFormSection />
      <ContactBenefitsSection />
    </>
  )
}
